import React from 'react';
import { Table, columnDefiner } from '../../atomic/table';
import { KintoneApp } from '../../../models/TenantModel';
import { IconButton } from '../../atomic/buttons';
import { Link } from 'react-router';
import { Icon, Icons } from '../../atomic/icons';
import { AdminKintoneAppFolderList } from './AdminKintoneAppFolderList';
import { getKintoneAppFolders } from '../../../APIs/foldersApi';

interface AppData extends KintoneApp {
    trClass: string;
}

const definer = columnDefiner<AppData>();
const columns = [
    definer.accessor('appId', {
        header: 'AppId',
        cell: (d) => {
            const { appId } = d.row.original;
            return (
                <>
                    <Link to={`/app/admin/kintone/app/${appId}/edit`}>
                        <Icon icon="fa-solid fa-pencil"></Icon>
                        {appId}
                    </Link>
                </>
            );
        },
    }),
    {
        header: '詳細',
        cell: (d: { row: { original: { appDescription: any } } }) => {
            const appDescription =
                d.row.original.appDescription == null
                    ? ''
                    : d.row.original.appDescription;
            return `${appDescription}`;
        },
    },
    {
        header: '削除',
        cell: (d: {
            row: { original: { appId: any } };
            table: { options: { onRemoveApp: any } };
        }) => {
            const { appId } = d.row.original;
            const { onRemoveApp } = d.table.options;
            return (
                <IconButton
                    icon="fa-solid fa-trash"
                    onClick={() => {
                        onRemoveApp(Number(appId));
                    }}
                ></IconButton>
            );
        },
    },
];

type AdminKintoneTableProp = {
    apps: KintoneApp[];
    setApps: React.Dispatch<React.SetStateAction<KintoneApp[]>>;
    onRemoveApp: Function;
};

export const AdminKintoneTable: React.FC<AdminKintoneTableProp> = ({
    apps,
    setApps,
    onRemoveApp,
}) => {
    const options = {
        onRemoveApp,
    };

    return (
        <>
            <Table
                className="app-table"
                data={apps}
                columns={columns}
                options={options}
            />
        </>
    );
};
